module.exports = __webpack_public_path__ + "static/banshee-f34b5457d1b7469f5010fa21a9050ebe.jpg";